module.exports = __webpack_public_path__ + "static/SEODevelopments_fullLogo-579bbbd4a09b405f6782ea03907e9978.png";